(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-mutate-content', actionFunc);

    function actionFunc(AccessMainCtrl, lodash) {
        return function(options, actionData, eventResponse) {
            const mainScope = AccessMainCtrl.get('mainScope');
            if (lodash.has(options, 'contentKey')) {
                let _replacement;
                if (lodash.has(options, 'modelKey')) {
                    _replacement = lodash.get(eventResponse, options.modelKey, '');
                }
                if (!lodash.has(options, 'modelKey')) {
                    _replacement = angular.copy(eventResponse);
                }
                lodash.set(mainScope, ['content', options.contentKey].join('.'), _replacement);
            }
        };
    }
})();